export { YotpoReviewsWidget } from '@/components/common/YotpoReviewsWidget/YotpoReviewsWidget';
